import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";

export default class CommonAPICalls {
    api;

    constructor() {
        this.api = Api;
        this.api.setUserToken();
    }

    async getSystemTenants() { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/tenant/`);
        if (res?.data?.status === 200) return res?.data?.data?.map((item) => {
            return {
                value: item.tenant_id,
                label: `${item.tenant_name} - ${item.tenant_code}`
            }
        });
        return res;
    }

    async getSystemApiDetails() { 
        const res = await this.api.axios().get(Settings.apiAppUrl+'/api-details/'); 
        if (res?.status === 200) return res?.data?.results?.map((item) => {
            return {
                value: item.api_id,
                label: item.api_name
            }
        });
        return res;
    }

    async getSystemAppMaster() { 
        const res = await this.api.axios().get(Settings.apiAppUrl+'/details/'); 
        if (res?.status === 200) return res?.data?.results?.map((item) => {
            return {
                value: item.app_id,
                label: item.app_name
            }
        });
        return res;
    }

    async getSystemStatus() { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/status/`);
        if (res?.data?.status === 200) return res?.data?.data?.map((item) => {
            return {
                value: item.value,
                label: item.name
            }
        });
        return res;
    }

    async getSystemPayloadApiDetails(queue_id, tenant) { 
        const res = await this.api.axios().get(Settings.apiUrl + `/migrate/v1/data_queue/${tenant}/${queue_id}`);
        if (res?.status === 200) return res?.data;
        return res;
    }

    async getSystemPayloadErrorDetails(queue_id) { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/data-queue/${queue_id}?fields=error_details`);
        if (res?.status === 200) return res?.data;
        return res;
    }

    async updateSystemDataQueue(queue_id, tenant, payload) { 
        const res = await this.api.axios().patch(Settings.apiUrl + `/migrate/v1/data_queue/${tenant}/${queue_id}/`,payload);
        if (res?.data?.status === 200) return res?.data
        return res;
    }

    async getSystemOperations() { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/operation-mappings/`);
        if (res?.data?.status === 200) return res?.data?.data?.map((item) => {
            return {
                value: item.operation_id,
                label: item.operation_name
            }
        });
        return res;
    }

    async getSystemExternalApi() { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/external-system-apis/`);
        if (res?.data?.status === 200) return res?.data?.data?.map((item) => {
            return {
                value: item.external_api_id,
                label: item.api_name
            }
        });
        return res;
    }
 
    async getSystemSourceMaster() { 
        const res = await this.api.axios().get(Settings.apiAppUrl + `/source-master/`);
        if (res?.status === 200) return res?.data?.results?.map((item) => {
            return {
                value: item.source_id,
                label: item.source_name
            }
        });
        return res;
    }
}